module.exports = __webpack_public_path__ + "static/img/14.38e437d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/zh/14.png
// module id = OqY9
// module chunks = 0